const React = require('react');
const PropTypes = require('prop-types');
const { StyledButton, StyledButtonTextContainer, StyledLoadingContainer } = require('./Button.styled');
const { withForwardRef } = require('../hocs');

function ButtonComponent(props) {
  const { a11yTitle, color, disabled, primary, children, forwardedRef, loading, ...rest } = props;

  const onClick = React.useCallback(
    (event) => {
      if (!disabled && props.onClick) props.onClick(event);
    },
    [props, disabled]
  );

  const showLoading = loading && !disabled;

  const loadingComponent = (show, isPrimary) =>
    React.createElement(
      StyledLoadingContainer,
      {
        $showLoading: show,
        primary: isPrimary
      },
      React.createElement('div', { className: 'bounce1' }),
      React.createElement('div', { className: 'bounce2' }),
      React.createElement('div', null)
    );

  return React.createElement(
    StyledButton,
    Object.assign({}, rest, {
      primary: primary,
      disabled: disabled,
      'aria-label': a11yTitle,
      color: color,
      onClick: onClick,
      ref: forwardedRef
    }),
    React.createElement(StyledButtonTextContainer, { $showLoading: showLoading }, children),
    loadingComponent(showLoading, primary)
  );
}

/**
 * Definition of default values for component props
 */
ButtonComponent.defaultProps = {
  children: {},
  a11yTitle: 'button',
  color: '',
  textColor: '',
  width: '100%',
  forwardedRef: null,
  primary: false,
  secondary: false,
  tertiary: false,
  disabled: false,
  loading: false,
  onClick: function onClick() {}
};

ButtonComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
  a11yTitle: PropTypes.string,
  textColor: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.string,
  forwardedRef: PropTypes.any,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func
};

const ButtonWrapper = withForwardRef(ButtonComponent);
ButtonWrapper.displayName = 'Button';

export const Button = ButtonWrapper;

